import React from "react";
import DetailImage from "../../components/DetailImage";
import FeedbackForm from "./FeedbackForm";
import {connect} from "react-redux";
import {fetchFromHub, postToHub} from "../../actions/networkActions";
import {PropTypes} from "prop-types";
import {getTranslation} from "../../translations/translationUtils";
import {DefaultButton, SecondaryButton} from "../../resources/styles";
import If from '../../components/If';
import {removeHtmlStyles} from "../../utils/stringUtils";
import browserHistory from '../../utils/history';

class Feedback extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profile: null,
            allInOne: false,
            canSend: false,
            sending: false,
            error: false,
            saved: false,
            conditions: null,
            conditionsAccepted: false,
            amountSubmitPressed: 0,
            combinedProfile: null
        };
        this._validated = this._validated.bind(this);
        this._sendFeedback = this._sendFeedback.bind(this);
        this._onConditionsAcceptChanged = this._onConditionsAcceptChanged.bind(this);
        this._feedbackData = null;
    }

    componentDidMount() {
        let id = null;

        if (this.props.match && this.props.match.params) {
            id = this.props.match.params.id;
        }

        if (this.props.profileId) {
            id = this.props.profileId;
            this.setState({allInOne: true});
        }

        if (id) {
            this.props.fetchFromHub(`ratings/profiles/` + id, this.updateProfile);
            this.props.fetchFromHub(`conditions/Rating`, this.updateConditions);
        }
    }

    isVaildQuestion = (question) => {
        const { inputRating, inputText, inputTextSmall } = question;

        // Supported cases:
        // 1. TextArea      → !stars, text, !small
        // 2. TextInput     → !stars, text, small
        // 3. Star Rating    → stars, !text, !small

        const isTextArea  = !inputRating &&  inputText && !inputTextSmall;
        const isTextInput = !inputRating &&  inputText &&  inputTextSmall;
        const isStarRating =  inputRating && !inputText && !inputTextSmall;
        
        return isTextArea || isTextInput || isStarRating;
    }

    updateProfile = (profile) => {
        this.setState({
            profile: profile,
        });

        // combinedProfile only used to sort items regardless of field or question
        let combinedProfile = profile;
        combinedProfile.items = [];

        for (let i = 0; i< profile.fields.length; i++) {
            const field = profile.fields[i];
            field.type = "field";
            combinedProfile.items.push(field);
        }

        for (let i = 0; i< profile.questions.length; i++) {
            const question = profile.questions[i];
            
            if(this.isVaildQuestion(question)){
                question.type = "question";
                combinedProfile.items.push(question);
            }
        }

        combinedProfile.items.sort((a, b) => {
                if (a.sortOrder > b.sortOrder) return 1;
                if (b.sortOrder > a.sortOrder) return -1;
                return 0;
            }
        );
        this.setState({combinedProfile: combinedProfile});
    };

    updateConditions = (conditions) => {
        this.setState({
            conditions: conditions,
        })
    };

    _validated(isValid) {
        this.setState({canSend: isValid});
    }

    _onConditionsAcceptChanged(event) {
        this.setState({conditionsAccepted: event.target.checked});
    }

    _sendFeedback() {
        const newAmountSubmitPressed = this.state.amountSubmitPressed + 1;
        this.setState({amountSubmitPressed: newAmountSubmitPressed});

        if (this._feedbackData == null) {
            return false;
        }
        if (!this._isSubmitPossible()) {
            console.warn("Form is invalid - do NOT submit");
            return false;
        }

        let answer = this._feedbackData.getFeedbackResult();
        console.log('answer', answer);
        this.setState({sending: true, error: false});
        this.props.postToHub('ratings/answer', answer, this.sendSuccess, this.sendError);

        return true;
    }

    sendSuccess = (response) => {
        if (response.failed) {
            this.setState({sending: false, error: true});
        }
        else {
            if(this.state.allInOne){
                this.props.markProfileAsSaved();
            }else{
                this.setState({sending: false, saved: true});
            }
        }
    };

    sendError = (response) => {
        console.error("answer saving error", response);
        this.setState({sending: false, error: true});
    };

    _renderSubmit() {
        if (this.state.sending) {
            return <i className="fa fa-spinner fa-pulse"></i>;
        }
        else if (this.state.saved) {
            return (
                <div className="grid-x">
                    <div className="flex items-center mb-2">
                        <i className="fa fa-check-square feedbackResponseIcon mr-2"></i>
                        <span>{this.context.t("feedback_thank_you_message")}</span>
                    </div>
                    <SecondaryButton onClick={() => browserHistory.goBack()}>
                        <i className="fa fa-chevron-left mr-2" />
                        {this.context.t("back")}
                    </SecondaryButton>
                </div>
            )
        }
        else {
            return (
                <DefaultButton
                       onClick={this._sendFeedback}>
                    {this.context.t("submitFeedback")}
                </DefaultButton>
            )
        }
    }

    _isSubmitPossible() {
        return this.state.canSend && (this.state.conditions && this.state.conditions.conditionText && this.state.profile.acceptTandC ? (this.state.conditions && this.state.conditions.conditionText && this.state.conditionsAccepted) : true );
    }


    render() {
        let profile = this.state.profile;
        if (profile === null) {
            return false;
        }

        let conditions = null;
        if (this.state.conditions != null && this.state.profile.acceptTandC) {
            conditions = this.state.conditions.conditionText;
        }

        const errorMessage = this.context.t("feedback_error_message");

        const checkboxPStyle = {
            marginBottom: "0"
        };

        if (this.state.allInOne) {
            return (
                <div>
                    <div className="feedbackForm">
                        <FeedbackForm ref={(d) => this._feedbackData = d} profile={profile}
                                      onValidChanged={this._validated}
                                      amountSubmitPressed={this.state.amountSubmitPressed}
                                      saved={this.state.saved}
                                      combinedProfile={this.state.combinedProfile}
                        />

                    </div>
                    <div className="feedbackResponse">
                        {this.state.error && (<div className="error-message">{errorMessage}</div>)}
                        {this._renderSubmit()}
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="grid-x grid-padding-x">
                        <div className="cell small-12 medium-4 large-4">
                            <DetailImage image={this.props.configuration.hubUrl + "blobs/image?reference=" + profile.id + "&width=400"}/>
                        </div>
                        <div className="cell small-12 medium-8 large-8 text-left">
                            <div className="row">
                                <h1 dangerouslySetInnerHTML={{__html: getTranslation(profile.title)}}/>
                                <p dangerouslySetInnerHTML={{__html: removeHtmlStyles(getTranslation(profile.description))}}/>
                            </div>
                            <div className="feedbackForm">
                                <FeedbackForm ref={(d) => this._feedbackData = d}
                                              profile={profile}
                                              combinedProfile={this.state.combinedProfile}
                                              onValidChanged={this._validated}
                                              amountSubmitPressed={this.state.amountSubmitPressed}
                                              saved={this.state.saved}
                                />
                                <If test={conditions}>
                                    <div>
                                        <p>
                                            <span dangerouslySetInnerHTML={{__html: removeHtmlStyles(getTranslation(conditions?.values))}}/>
                                        </p>
                                        <p style={checkboxPStyle}>
                                            <label><input type="checkbox" disabled={this.state.saved} className="whaleCheckbox" onClick={this._onConditionsAcceptChanged}/>{this.context.t("basket_accept_conditions")}</label>
                                        </p>
                                        <If test={this.state.amountSubmitPressed > 0 && !this.state.conditionsAccepted && !this.state.saved}>
                                            <div className="feedbackMandatoryMissing">{this.context.t("feedback_termsandconditions_must_be_accepted")}</div>
                                        </If>
                                    </div>
                                </If>
                            </div>

                            <div className="feedbackResponse">
                                {this.state.error && (<div className="error-message">{errorMessage}</div>)}
                                {this._renderSubmit()}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

    }
}

const mapStateToProps = state => {
    // lang used to trigger rerender in new language when changed
    return {
        configuration: state.configuration,
        lang: state.i18nState.lang
    };
};

Feedback.contextTypes = {
    t: PropTypes.func.isRequired
};


export default connect(mapStateToProps, {fetchFromHub: fetchFromHub, postToHub: postToHub})(Feedback);